import {
  GET_FILTERS_DATA,
  GET_FILTERS_DATA_SUCCESS,
  GET_FILTERS_DATA_FAIL,
  SET_FILTERS_DATA,
  SET_FILTERS_DATA_SUCCESS,
  SET_FILTERS_DATA_FAIL,
} from "./actionTypes";

const INIT_STATE = {
  filtersData: {
    startDate: "",
    endDate: "",
    staff: "staff",
    status: "status",
    type: "type",
  },
};

const Filters = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_FILTERS_DATA:
      return { ...state, loading: true };

    case GET_FILTERS_DATA_SUCCESS:
      return {
        ...state,
        filtersData: action.payload,
      };
    case GET_FILTERS_DATA_FAIL:
      return {
        ...state,
        filtersData: [],
      };
    case SET_FILTERS_DATA:
      return { ...state, loading: true };

    case SET_FILTERS_DATA_SUCCESS:
      return {
        ...state,
        filtersData: action.payload,
      };
    case SET_FILTERS_DATA_FAIL:
      return {
        ...state,
        filtersData: [],
      };

    default:
      return state;
  }
};

export default Filters;
